


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VSpin from './VSpin.vue'
import { usePhoneConfirmationCommand, useSendCodeCommand } from '@/app/asyncStates/userStates'
import { apiKey } from '@/api/configuration/config'
import { useAsyncStateErrorHandler } from '@/infranstructure/useAsyncStateErrorHandler'
import { useSignCommand } from '@/app/asyncStates/processStates'
import { useAsyncState } from '@/infranstructure/useAsyncState'
import { otpPhoneVerificationResponse } from '@/models/digitalIdentities/otp/models'
import PhoneLikeConfirmationForm from './phoneLikeConfirmation/PhoneLikeConfirmationForm.vue'

type UploadTransactionPayload = { id: string; uid: string }

@Component({
  components: {
    VSpin,
    PhoneLikeConfirmationForm,
  },
})
export default class PhoneConfirmation extends Vue {
  @Prop({ type: String, required: true }) public payload!: string
  @Prop({ type: String, required: true }) public id!: string
  @Prop({ type: String, required: true }) public uid!: string

  // ✅ Команды, которые НЕ зависят от пропсов
  private verify = useSendCodeCommand(apiKey, useAsyncStateErrorHandler)
  private generateCode = usePhoneConfirmationCommand(apiKey, useAsyncStateErrorHandler)
  
  // ✅ Команды, которые зависят от пропсов — инициализируем в created()
  private sign: any = null
  private uploadTransaction: any = null
  
  // ✅ Флаги загрузки для команд, которые создаются динамически
  private signIsLoading = false
  private uploadTransactionIsLoading = false
  
  private otpVerification: any = { GenerationNumber: 0 }
  private code = ''

  // ✅ Computed для общего состояния загрузки
  get isLoading(): boolean {
    return this.verify.isLoading || this.signIsLoading || this.generateCode.isLoading || this.uploadTransactionIsLoading
  }

  created() {
    this.setDefaultState()
    // ✅ Инициализируем команды, которые зависят от пропсов
    this.sign = useSignCommand(this.id, this.uid)
    this.uploadTransaction = useAsyncState<unknown, [UploadTransactionPayload]>(
      (params) => this.$store.dispatch('uploadTransaction', params),
      useAsyncStateErrorHandler,
      { immediate: false },
    )
  }

  @Watch('payload')
  public onPayloadChanged() {
    this.setDefaultState()
  }

  public setDefaultState() {
    this.code = ''
    if (this.payload) {
      try {
        this.otpVerification = otpPhoneVerificationResponse(this.payload)
      } catch (e) {
        console.error('Ошибка декодирования payload:', e)
        this.otpVerification = { GenerationNumber: 0 }
      }
    } else {
      this.otpVerification = { GenerationNumber: 0 }
    }
  }

  public async onVerifyCode(code: string) {
    const command = {
      data: this.payload,
      code: code,
    }
    await this.verify.execute(0, command)
    if (this.verify.state.isValid) {
      this.signIsLoading = true
      try {
        await this.sign.execute()
        this.uploadTransactionIsLoading = true
        await this.uploadTransaction.execute(0, { id: this.id, uid: this.uid })
        this.$router.push(`/confirmation/${this.id}/${this.uid}`)
      } finally {
        this.signIsLoading = false
        this.uploadTransactionIsLoading = false
      }
    } else {
      this.$notify({ title: 'Ошибка', message: 'Введен неверный код подтверждения', color: '#FF5252' })
    }
  }

  public onConfirmationCodeInput(value: string) {
    this.code = value
  }

  public async onResendCode() {
    const response = await this.generateCode.execute(0, this.payload)
    this.$router.replace({ name: 'phone-confirmation', params: { payload: response.data, id: this.id, uid: this.uid } })
  }
}
